import React from 'react';
import { useReveal } from '../../hooks/useReveal';

/**
 * Wraps children in a div that fades/slides into view the first time it
 * enters the viewport. Purely presentational — no effect on the wrapped
 * component's own styling or behaviour.
 */
export function Reveal({ as: Tag = 'div', delay = 0, className = '', children }) {
  const [ref, visible] = useReveal();
  return (
    <Tag
      ref={ref}
      className={`reveal${visible ? ' reveal-visible' : ''}${className ? ` ${className}` : ''}`}
      style={{ transitionDelay: visible ? `${delay}ms` : '0ms' }}
    >
      {children}
    </Tag>
  );
}
